import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { useField, useFormikContext } from 'formik';

import FormikInputGroup from '@components/smartAdminUI/input/FormikInputGroup';
// Contains one numeric field and one units lookup field

const OneDMeasurement = props => {
  const { fields, validateFigField } = props;
  const { setFieldValue } = useFormikContext();

  const [currUnit, setCurrUnit] = useState('');

  const areaField = useMemo(() => fields.find(field => !(field.FieldName.toUpperCase().includes('UNITS'))), [fields]);
  const unitsField = useMemo(() => fields.find(field => field.FieldName.toUpperCase().includes('UNITS')), [fields]);

  const [areaFormikField] = useField(areaField?.FieldName);
  const [unitsFormikField] = useField(unitsField?.FieldName);

  // updates current unit value from formik
  useEffect(() => {
    if (unitsFormikField.name) {
      if (!isEmpty(unitsFormikField.value)) {
        setCurrUnit(unitsFormikField.value);
      }
    }
  }, [unitsFormikField]);

  const convertFieldMeasurements = () => {
    let areaValue = parseFloat(areaFormikField.value);
    /*
      currUnit is the measurement we are changing from
      unitsFormikField is the measurement we are changing to
    */

    switch (currUnit) {
      case 'AC': {
        switch (unitsFormikField.value) {
          case 'HA': {
            areaValue /= 2.471;
            break;
          }
          case 'SF': {
            areaValue *= 43560;
            break;
          }
          case 'SM': {
            areaValue /= 0.000247105;
            break;
          }
          default: break;
        }
        break;
      }
      case 'HA': {
        switch (unitsFormikField.value) {
          case 'AC': {
            areaValue *= 2.471;
            break;
          }
          case 'SF': {
            areaValue *= 107639;
            break;
          }
          case 'SM': {
            areaValue *= 10000;
            break;
          }
          default: break;
        }
        break;
      }
      case 'SF': {
        switch (unitsFormikField.value) {
          case 'AC': {
            areaValue /= 43560;
            break;
          }
          case 'HA': {
            areaValue /= 107640;
            break;
          }
          case 'SM': {
            areaValue *= 0.09290304;
            break;
          }
          default: break;
        }
        break;
      }
      case 'SM': {
        switch (unitsFormikField.value) {
          case 'AC': {
            areaValue *= 0.000247105;
            break;
          }
          case 'HA': {
            areaValue /= 10000;
            break;
          }
          case 'SF': {
            areaValue *= 10.7639104167;
            break;
          }
          default: break;
        }
        break;
      }
      default: break;
    }

    setFieldValue(areaField.FieldName, areaValue);
    setCurrUnit(unitsFormikField.value);
  };

  useEffect(() => {
    if (unitsFormikField.value !== currUnit && areaFormikField.value > 0) {
      convertFieldMeasurements();
    }
  }, [unitsFormikField.value, areaFormikField.value]);

  return (
    <div className="form-row">
      <div className="form-group col-md-8">
        <FormikInputGroup
          {...areaField}
          key={areaField.RowID}
          validateFigField={validateFigField}
        />
      </div>
      <div className="form-group col-md-4">
        <FormikInputGroup
          {...unitsField}
          key={unitsField.RowID}
          validateFigField={validateFigField}
        />
      </div>
    </div>
  );
};

OneDMeasurement.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape()),
  validateFigField: PropTypes.func.isRequired,
};

export default OneDMeasurement;
